var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/other_location.a2fa3464.png","uri@2x": __webpack_public_path__ + "static/media/other_location.1f8bf3f9.png","uri@3x": __webpack_public_path__ + "static/media/other_location.8459fd99.png",
    width: 24,
    height: 24
});